import { render } from "./WheelbitPage.vue?vue&type=template&id=3fcec531&scoped=true"
import script from "./WheelbitPage.vue?vue&type=script&lang=js"
export * from "./WheelbitPage.vue?vue&type=script&lang=js"

import "./WheelbitPage.vue?vue&type=style&index=0&id=3fcec531&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcec531"]])

export default __exports__